import React from 'react';
import Icon from './Icon';

export default function PageHeading({ eyebrow, title, description, icon='book', aside }) {
  return <header className="page-intro">
    <div className="page-intro__text">
      {eyebrow && <span className="eyebrow"><Icon name="sparkles" size={15}/>{eyebrow}</span>}
      <h1>{title}</h1>
      {description && <p>{description}</p>}
    </div>
    {aside || <div className="page-intro__symbol" aria-hidden="true"><Icon name={icon} size={40}/></div>}
  </header>;
}
